import { render, staticRenderFns } from "./JoinUsView.vue?vue&type=template&id=241d579a&scoped=true"
import script from "./JoinUsView.vue?vue&type=script&lang=js"
export * from "./JoinUsView.vue?vue&type=script&lang=js"
import style0 from "./JoinUsView.vue?vue&type=style&index=0&id=241d579a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d579a",
  null
  
)

export default component.exports